// extracted by mini-css-extract-plugin
export var BlockRow = "BlockRow-module--BlockRow--3zj9t";
export var Background = "BlockRow-module--Background--UpU8R";
export var NoPadding = "BlockRow-module--NoPadding--ftQPZ";
export var MobileReverse = "BlockRow-module--MobileReverse--2kGjG";